import { ImageSourceSizes } from '@ag1/ui';
import { buttonClickEvent } from 'analytics/events/studio';
import { StudioBaseImageV2 } from 'shared/studio/StudioBaseImage/StudioBaseImage';
import { SanityImageAsset, SanityReference } from 'types/studio/studio';
import styles from './SocialMediaImage.module.scss';

type Props = {
  baseImage?: {
    asset: SanityReference<SanityImageAsset>;
    alt?: string;
  };
  imageLink?: string;
  sectionType: string;
  sizes: ImageSourceSizes;
  visibleOnPageLoad: boolean;
};

const SocialMediaImage = ({
  baseImage,
  imageLink,
  sectionType,
  sizes,
  visibleOnPageLoad
}: Props) => {
  if (!baseImage || !imageLink) {
    return null;
  }

  function handleSocialMediaClick() {
    buttonClickEvent({
      clickText: baseImage?.alt ? baseImage?.alt : 'Social Media Image',
      url: imageLink,
      location: sectionType
    });
  }

  return (
    <a
      href={imageLink}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Opens in a new tab"
      onClick={() => handleSocialMediaClick()}
      data-gtm-skip-global>
      <StudioBaseImageV2
        image={baseImage}
        sizes={sizes}
        eagerLoading={visibleOnPageLoad}
        className={styles.image}
      />
    </a>
  );
};

export default SocialMediaImage;
